export default __webpack_public_path__ + "static/media/hd1.79b73aab.webp";